import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class UserSettingsServiceAgent extends ServiceBase {
    /**
     * Gets all user settings as flat key/value list.
     * @returns {Promise}
     */
    getUserSettings = () => {
        const token = this.getToken();
        const url = `${baseUrl}/${service}/user/settings`;
        const config = { headers: { Authorization: `Bearer ${token}` } };
        return agent.get(url, config);
    };

    /**
     * Upserts a single user setting.
     * @param {string} key
     * @param {*} value
     * @returns {Promise}
     */
    postUserSetting = (key, value) => {
        const url = `${baseUrl}/${service}/user/settings`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: [{ key, value: String(value) }] }, config);
    };
}

const userSettingsService = new UserSettingsServiceAgent();
export default userSettingsService;
